import UploadFileOutlinedIcon from "@mui/icons-material/UploadFileOutlined";
import { Box, Button, Typography } from "@mui/material";
import { baseTheme } from "../../../themes/shipinsure";

export function UploadDocumentsCard({ supportEmail, claimNumber, t }) {
  if (!supportEmail) {
    return null;
  }

  const subject = encodeURIComponent(
    `Documents for claim ${claimNumber}`,
  );
  const body = encodeURIComponent(
    `Hi,\n\nPlease find attached the requested documents for claim ${claimNumber}.\n\n`,
  );
  const href = `mailto:${supportEmail}?subject=${subject}&body=${body}`;

  return (
    <Box
      mb="16px"
      sx={{
        border: `1px solid ${baseTheme.colors.primary}`,
        borderRadius: "12px",
        padding: "16px",
        backgroundColor: "#F7F8FF",
      }}
    >
      <Typography fontWeight={700} mb="6px" fontSize="1.05rem">
        {t("status.nextSteps.documentsTitle")}
      </Typography>
      <Typography fontSize="14px" color="#2F4668" mb="12px">
        {t("status.nextSteps.documentsBody")}
      </Typography>
      <Button
        variant="contained"
        startIcon={<UploadFileOutlinedIcon />}
        href={href}
      >
        {t("status.uploadDocuments")}
      </Button>
    </Box>
  );
}
